export const SEO_TEXTS = 'seo_texts'
export const MODELS = 'models'
export const POJECTS = 'projects'
export const GOODS = 'goods'
export const SUBSCRIPTION_ME = 'subscription_me'
export const TRANSLATE = 'translate'
